import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import {
	Grid,
	Card,
	CardHeader,
	CardContent,
	Avatar,
	Box,
	TextField,
	RadioGroup,
	Radio,
	FormControl,
	FormControlLabel,
	FormLabel,
	Button,
	Checkbox,
	Dialog,
	DialogActions,
	DialogTitle,
	DialogContent,
	DialogContentText,
	Backdrop,
	CircularProgress,
} from "@material-ui/core";

import { SIREN_CONFIG, SIREN_COLOR } from "config.js";
import { red } from '@material-ui/core/colors';

import InsightsIcon from '@mui/icons-material/Insights';
import AccessibilityIcon from '@material-ui/icons/Accessibility';
import NightsStayIcon from '@mui/icons-material/NightsStay';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';

import DateFnsUtils from '@date-io/date-fns'; //yarn add date-fns
import {
	MuiPickersUtilsProvider,
	KeyboardDatePicker,
} from '@material-ui/pickers';
import {useSelector} from 'react-redux';
import Chart from "react-google-charts";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import moment from 'moment';
import Typography from '@material-ui/core/Typography';
import "./HealthDataByRoom.css";
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { FormattedMessage, useIntl } from "react-intl";



/**
 * 일자별 헬스데이터 조회
 * 	선택된 일자의 모든 환자 헬스데이터를 다룬다.
 * @param {*} props 
 * @returns 
 */
const HealthDataByRoom = (props) => {

	const { className, users, queryParams, ...rest } = props;
	const classes = useStyles();
	const {formatMessage} = useIntl();


	const [graphData4, setGraphData4] = useState({});
	const facility_id = useSelector((store) => store.user.facility_id);

	//어제 일자를 디폴트로 함
	const [selectedDate, setSelectedDate] = useState(new Date((new Date()).valueOf() - (1000 * 60 * 60 * 24)));
	// const [selectedDate, setSelectedDate] = useState(  moment().subtract(1, 'days') );
	const [groupByDevice, setGroupByDevice] = useState(false);
	const [openDialog, setOpenDialog] = useState(false);

	//검색기간: default 14일
	const [selectedPeriod, setSelectedPeriod]  = useState(14);

	const [selectedRoomId, setSelectedRoomId] = useState('');

	const [roomList, setRoomList] = useState([]);

	const [loading, setLoading] = useState(false);

	const [roomSummary, setRoomSummary] = useState(null);
	const [searched, setSearched] = useState(false);

	const handleDateChange = (date) => {
		setSelectedDate(date);
	}


	/**
	 * 룸 정보를 얻는다
	 */
	const loadRoomList = () => {

		var roomlist = [];

		var url = `${SIREN_CONFIG.HOSTNAME}/room/roomlistWithPatient?facility_id=${facility_id}`;

		const opt = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};

		fetch(url, opt)
			.then( (response) => {
				return response.json();
			})
			.then( (responseData) => {
				responseData.resultData.map(function(row){
					roomlist.push(
						{roomId: row['roomId'], roomName: row['roomName'], patientName: row['patientName']}
					);
				});
			})
			.then( () => {
				setRoomList(roomlist);
			});
	}



	const onRadioChagne = (event) => {

		if (event.target.value == "1_weeks"){
			setSelectedPeriod(6);
		} else if (event.target.value == "4_weeks"){
			setSelectedPeriod(27);
		} else {
			//as default, 14일, 2주를 부여함
			setSelectedPeriod(13);
		}
	}


	/**
	 * 병실별 원본(raw) 활동 그래프 조회
	 */
	const fetchRawGraph = (startTime, endTime) => {

		var arr_bar = [];

		var url = `${SIREN_CONFIG.HOSTNAME}/activities/getDataByRoom?facility_id=${facility_id}&roomId=${selectedRoomId}&startTime=${startTime}&endTime=${endTime}&isGroupByDevice=${groupByDevice}`;

		const opt = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};

		return fetch(url, opt)
			.then( (response) => {
				return response.json();
			})
			.then( (responseData) => {

				// cnt  =0 , 부재
				// cnt >= 1, 재실 표시 안함
				// 	ratio >= 5.0 활동 or 미활동
					// - ratio >= 7.0 활동
					// - ratio <= 3.0 미활동

				responseData.resultData.map(function(row){

					arr_bar.push(
						[
							row['date'],
							// row['act_label'],
							formatMessage({id:row['act_label']}),
							row['act_color'],
							new Date(0, 0, 0, row['stime_h'], row['stime_m'], 0),
							new Date(0, 0, 0, row['etime_h'], row['etime_m'], 0),
						]
					);
				});

			}).then( () => {

				//그래프 메타 데이터
				var test_data = [];

				if (arr_bar.length > 0 ){

					test_data =
					[
						[
						  { type: 'string', id: 'date' },
						  { type: 'string', id: 'act' },
						  { type: 'string', id: 'style', role: 'style' }, //color
						  { type: 'date', id: 'Start' },
						  { type: 'date', id: 'End' },
						],
					];


					if (arr_bar.length > 0 ){
						test_data = test_data.concat(arr_bar);
					}
				}

				setGraphData4(test_data);
			})
			.catch((error) => {
				console.error("병실별 빅데이터 조회 오류:", error);
				alert(formatMessage({ id: 'ai_error_fetch_generic' }) + error.message);
			});
	}


	/**
	 * 병실별 AI 요약(재실 패턴 / 야간 활동) 조회
	 */
	const fetchRoomSummary = (startTime, endTime) => {

		var url = `${SIREN_CONFIG.HOSTNAME}/insights/roomSummary?facility_id=${facility_id}&roomId=${selectedRoomId}&startDate=${startTime}&endDate=${endTime}&locale=${localStorage.getItem("locale") || "ko"}`;

		return fetch(url, { method: "GET", headers: { "Content-Type": "application/json" } })
			.then((response) => response.json())
			.then((responseData) => {
				if (responseData.resultCode === '000') {
					setRoomSummary(responseData.resultData);
				} else {
					setRoomSummary(null);
				}
			})
			.catch((error) => {
				console.error("AI 요약 조회 오류:", error);
				setRoomSummary(null);
			});
	}


	const doSearchData = () => {

		if (selectedRoomId === ""){
			setOpenDialog(true);
			return;
		}

		var startTime = moment(selectedDate).subtract(selectedPeriod, "days").format('YYYY-MM-DD')
		var endTime = moment(selectedDate).add(1, 'days').format('YYYY-MM-DD');

		setLoading(true);

		Promise.all([
			fetchRawGraph(startTime, endTime),
			fetchRoomSummary(startTime, endTime),
		]).finally(() => {
			setLoading(false);
			setSearched(true);
		});
	}


	useEffect(() => {
		if (roomList.length === 0 ){
			loadRoomList();
		}
	}, []);


	const selectedRoomName = (roomList.find((r) => r.roomId === selectedRoomId) || {}).roomName || '';


	return (

		<div className={classes.root}>

			<Backdrop className={classes.backdrop} open={loading}>
				<div className={classes.backdropContent}>
					<CircularProgress color="inherit" size={56} thickness={4} />
					<Typography variant="body1" className={classes.backdropText}>
						<FormattedMessage id="common_loading_data" />
					</Typography>
				</div>
			</Backdrop>

			<Grid container justify="center" spacing={1}>
				<Grid item lg={1} xs={2} >
					<Card className={classes.legend_root}>
						<CardHeader
							className={classes.emergency_title}
							title={formatMessage({id:'emergency_board_title'})}
							titleTypographyProps={{ color: 'inherit', variant: 'h5', align: 'center' }}
						/>
					</Card>
				</Grid>

				<Grid item lg={1} xs={2} >
					<Card className={classes.legend_root}>
						<CardHeader
							className={classes.caution_title}
							title={formatMessage({id:'caution_board_title'})}
							titleTypographyProps={{ color: 'inherit', variant: 'h5', align: 'center' }}
						/>
					</Card>
				</Grid>

				<Grid item lg={1} xs={2} >
					<Card className={classes.legend_root}>
						<CardHeader
							className={classes.activity_title}
							title={formatMessage({id:'activity_target'})}
							titleTypographyProps={{ color: 'inherit', variant: 'h5', align: 'center' }}
						/>
					</Card>
				</Grid>

				<Grid item lg={1} xs={2} >
					<Card className={classes.legend_root}>
						<CardHeader
							className={classes.quiver_title}
							title={formatMessage({id:'quiver_target'})}
							titleTypographyProps={{ color: 'inherit', variant: 'h5', align: 'center' }}
						/>
					</Card>
				</Grid>

				<Grid item lg={1} xs={2} >
					<Card className={classes.legend_root}>
						<CardHeader
							className={classes.non_activity_title}
							title={formatMessage({id:'inactivity_target'})}
							titleTypographyProps={{ color: 'inherit', variant: 'h5', align: 'center' }}
						/>
					</Card>
				</Grid>

				<Grid item lg={1} xs={2} >
					<Card className={classes.legend_root}>
						<CardHeader
							className={classes.absence_title}
							title={formatMessage({id:'absence'})}
							titleTypographyProps={{ color: 'inherit', variant: 'h5', align: 'center' }}
						/>
					</Card>
				</Grid>

			</Grid>

			<Box component="span" display="block" p={1} m={1} />

			<Grid container item md={12} xs={12} spacing={1}>

				<Grid container item lg={4} xs={4} justify="flex-start" >
					<Autocomplete
						id="select-room"
						style={{ width: 240 }}
						options={ roomList }
						classes={{ option: classes.options, }}
						autoHighlight
						getOptionLabel={(option) => (option.roomName ? option.roomName : "") }
						getOptionSelected={ (option, value) => option.roomName === value.roomName }
						renderOption={(option) => (
							<React.Fragment>
								{option.roomName} - {option.patientName}
							</React.Fragment>
						)}

						renderInput={(params) => (
							<TextField
							{...params}
							label={formatMessage({id:'emergency_history_select_room'})}
							variant="outlined"
							inputProps={{
								...params.inputProps,
								autoComplete: 'new-password', // disable autocomplete and autofill
							}}
							/>
						)}

						onChange={(event, newValue) => {
							setSelectedRoomId(newValue ? newValue.roomId : '');
						}}
					/>


				<FormControlLabel
					style={{marginLeft: '16px'}}
					control={
						<Checkbox
						checked={groupByDevice}
						onChange={ () => setGroupByDevice(!groupByDevice) }
						// name="센서별"
						sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
						/>
					}
					label={
						<Typography style={{ fontSize: 18 }}><FormattedMessage id="sensor_sort" /></Typography>
					}
				/>
				</Grid>


				<Grid container item lg={4} xs={4}  alignItems="center" justify="center" direction="row">

					<div className="input-container">
						<MuiThemeProvider theme={theme}>
							<MuiPickersUtilsProvider utils={DateFnsUtils}>
								<KeyboardDatePicker
									// maxDate={moment().subtract(1,"days")}
									autoOk
									maxDate={moment()}
									variant="inline"
									id="date-picker-dialog"
									format="yyyy-MM-dd"
									// fontSize="20"
									value={selectedDate}
									onChange={handleDateChange}
									KeyboardButtonProps={{'aria-label': 'change date',}}
									className={classes.datepicker}
									InputProps={{
										style: {
										  fontSize: 20,
										  height: 44,
										}
									  }}
									  style={{
										width: 160,
									  }}
								/>
							</MuiPickersUtilsProvider>
						</MuiThemeProvider>
					</div>
				</Grid>

				<Grid container item lg={3} xs={4}  alignItems="center" justify="flex-end" direction="row">

					<FormLabel component="legend"><FormattedMessage id="healthdata_by_room_query_period" />&nbsp;&nbsp;&nbsp;&nbsp;</FormLabel>
					<RadioGroup row aria-label="search_period" name="search_period" defaultValue="2_weeks" onChange={onRadioChagne}>
						<FormControlLabel
							value="1_weeks" control={<Radio color="primary" />}
							label={formatMessage({id:'healthdata_by_room_query_1week'})}
							labelPlacement="end"/>

						<FormControlLabel
							value="2_weeks" control={<Radio color="primary" />}
							label={formatMessage({id:'healthdata_by_room_query_2week'})}
							labelPlacement="end"/>

						<FormControlLabel
							value="4_weeks" control={<Radio color="primary" />}
							label={formatMessage({id:'healthdata_by_room_query_4week'})}
							labelPlacement="end"/>

					</RadioGroup>
				</Grid>

				<Grid container item lg={1} xs={1}>
					<Button size="large" variant="contained" color="primary" fullWidth onClick={doSearchData}>
						<FormattedMessage id="search" />
					</Button>
				</Grid>

			</Grid>


			<Box component="span" display="block" p={1} m={1} />

			{/* AI 요약 */}
			<Grid container item md={12} xs={12} spacing={2}>

				{roomSummary ? (
					<>
						<Grid item xs={12}>
							<div className={classes.aiSummaryHeader}>
								<Avatar className={classes.aiSummaryHeaderAvatar}><InsightsIcon /></Avatar>
								<div>
									<Typography variant="h6" className={classes.aiSummaryHeaderTitle}>
										{formatMessage({ id: 'ai_room_summary_title' }, { room: selectedRoomName })}
									</Typography>
									<Typography variant="body2" className={classes.aiSummaryHeaderSubtitle}>
										{formatMessage({ id: 'ai_room_summary_subtitle' }, { days: roomSummary.periodDays })}
									</Typography>
								</div>
							</div>
						</Grid>

						<Grid item xs={12} sm={6}>
							<Card className={classes.miniCard}>
								<CardContent className={classes.miniCardContent}>
									<Avatar className={classes.miniCardAvatar} style={{ backgroundColor: '#4F46E5' }}>
										<AccessibilityIcon />
									</Avatar>
									<div>
										<Typography variant="h4" className={classes.miniCardValue}>
											{roomSummary.occupancy.avgPresenceRatio != null
												? `${Math.round(roomSummary.occupancy.avgPresenceRatio * 100)}%`
												: formatMessage({ id: 'common_no_data_value' })}
										</Typography>
										<Typography variant="body2" color="textSecondary"><FormattedMessage id="ai_occupancy_label" /></Typography>
										{roomSummary.occupancy.trend !== 'flat' && (
											<div className={classes.trendRow}>
												{roomSummary.occupancy.trend === 'up'
													? <TrendingUpIcon style={{ color: SIREN_COLOR.EMERGENCY_COLOR, fontSize: 16 }} />
													: <TrendingDownIcon style={{ color: SIREN_COLOR.ACTIVITY_COLOR, fontSize: 16 }} />}
												<Typography variant="caption" color="textSecondary">
													<FormattedMessage id={roomSummary.occupancy.trend === 'up' ? 'ai_room_trend_up' : 'ai_room_trend_down'} />
												</Typography>
											</div>
										)}
									</div>
								</CardContent>
							</Card>
						</Grid>

						<Grid item xs={12} sm={6}>
							<Card className={classes.miniCard}>
								<CardContent className={classes.miniCardContent}>
									<Avatar className={classes.miniCardAvatar} style={{ backgroundColor: '#7C3AED' }}>
										<NightsStayIcon />
									</Avatar>
									<div>
										<Typography variant="h4" className={classes.miniCardValue}>
											{roomSummary.nightActivity.nightAvgActivity != null
												? Math.round(roomSummary.nightActivity.nightAvgActivity)
												: formatMessage({ id: 'common_no_data_value' })}
										</Typography>
										<Typography variant="body2" color="textSecondary"><FormattedMessage id="ai_night_activity_label" /></Typography>
										{roomSummary.nightActivity.nightToDayRatio != null && (
											<Typography variant="caption" color="textSecondary">
												{formatMessage({ id: 'ai_night_ratio_label' }, { ratio: Math.round(roomSummary.nightActivity.nightToDayRatio * 100) })}
											</Typography>
										)}
									</div>
								</CardContent>
							</Card>
						</Grid>

						<Grid item xs={12}>
							<Card className={classes.insightCard}>
								<CardHeader
									avatar={<Avatar className={classes.miniCardAvatar} style={{ background: GRADIENT }}><EmojiObjectsIcon /></Avatar>}
									title={formatMessage({ id: 'ai_insight_title' })}
									subheader={formatMessage({ id: 'ai_insight_subtitle' })}
									titleTypographyProps={{ variant: 'h6' }}
								/>
								<CardContent>
									{roomSummary.insightSentences && roomSummary.insightSentences.length > 0 ? (
										roomSummary.insightSentences.map((sentence, idx) => (
											<div key={idx} className={classes.insightRow}>
												<span className={classes.insightBullet} />
												<Typography variant="body1">{sentence}</Typography>
											</div>
										))
									) : (
										<Typography variant="body2" color="textSecondary"><FormattedMessage id="ai_insight_empty" /></Typography>
									)}
								</CardContent>
							</Card>
						</Grid>
					</>
				) : (
					<Grid item xs={12}>
						<Typography
							className={classes.dividerInset}
							color="textSecondary"
							display="block"
							align="center"
							variant="h6"><FormattedMessage id="ai_room_summary_placeholder" /></Typography>
					</Grid>
				)}

			</Grid>

			<Box component="span" display="block" p={2} m={1} />

			<Typography variant="h6" className={classes.sectionTitle}><FormattedMessage id="ai_section_title_raw_graph" /></Typography>

			<Grid container item md={12} xs={12} spacing={1}  justify = "center">

				{ !searched ?
				<Typography
					className={classes.dividerInset}
					color="textSecondary"
					display="block"
					align="center"
					variant="h6"><FormattedMessage id="ai_room_graph_placeholder" /></Typography>
				: graphData4.length > 1 ?
				<Chart
					width={'100%'}
					 height={'820px'}
					chartType="Timeline"
					loader={<div>Loading Chart</div>}

					data={graphData4}

					options={{
					//   height: '100px',
					hAxis: {
							format:'HH',
							title:'x',
							// gridlines: {
							// 	count: -1,
							// 	units: {
							// 	  hours: {format: ['HH', 'ha']},
							// 	}
							//   },
						},
					// vAxis: {
					// 	title: 'y'
					// },
					timeline: {
						rowLabelStyle: {
							fontName: 'Helvetica',
							fontSize: 15,
							color: '#603913',
							padding: '12px'
						},
						barLabelStyle: {
							fontName: 'Garamond',
							fontSize: 15 //bar height
						},
						colorByRowLabel: true,
					},
					animation: {
						// duration: 1000,
						easing: 'linear',
						startup: true

						},

						showRowNumber: true,

					// colors: ['#cbb69d', '#603913', '#c69c6e'],
					// timeline: { showRowLabels: false },
					avoidOverlappingGridLines: false,
					}}
					rootProps={{ 'data-testid': '1' }}
				/>
				: <Typography
					className={classes.dividerInset}
					color="textSecondary"
					display="block"
					variant="h4"><FormattedMessage id="not_data" /></Typography>}

			</Grid>


			<Dialog open={openDialog} onClose={() => {setOpenDialog(false)} }>
				<DialogTitle><FormattedMessage id="caution_board_title" /></DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						<FormattedMessage id="emergency_history_select_room" />
					</DialogContentText>
				</DialogContent>

				<DialogActions>
					<Button variant="outlined" color="secondary" onClick={() => {setOpenDialog(false)} }>Close</Button>
				</DialogActions>

			</Dialog>
		</div>

	);
};


export default HealthDataByRoom;


const GRADIENT = 'linear-gradient(90deg, #4F46E5 0%, #7C3AED 55%, #06B6D4 100%)';


const theme = createMuiTheme({
	overrides: {
	   MuiInputBase: {
		input: {
		//   background: '#dd7711',
		//   padding: 10,
			fontSize: '18px',
		},
	   },
	  },
})


const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(2),
	},
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		color: '#fff',
	},
	backdropContent: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: theme.spacing(2),
	},
	backdropText: {
		color: '#fff',
	},
	sectionTitle: {
		fontWeight: 600,
		marginBottom: theme.spacing(1),
	},
	aiSummaryHeader: {
		display: 'flex',
		alignItems: 'center',
		gap: theme.spacing(2),
		background: GRADIENT,
		borderRadius: 12,
		padding: theme.spacing(2, 3),
		marginBottom: theme.spacing(1),
		boxShadow: '0 4px 14px rgba(79, 70, 229, 0.25)',
	},
	aiSummaryHeaderAvatar: {
		backgroundColor: 'rgba(255,255,255,0.2)',
		width: 48,
		height: 48,
	},
	aiSummaryHeaderTitle: {
		color: '#fff',
		fontWeight: 700,
	},
	aiSummaryHeaderSubtitle: {
		color: 'rgba(255,255,255,0.85)',
	},
	miniCard: {
		height: '100%',
		borderRadius: 12,
		boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
	},
	miniCardContent: {
		display: 'flex',
		alignItems: 'center',
		gap: theme.spacing(2),
	},
	miniCardAvatar: {
		width: 52,
		height: 52,
		color: '#fff',
	},
	miniCardValue: {
		fontWeight: 700,
		lineHeight: 1.2,
	},
	trendRow: {
		display: 'flex',
		alignItems: 'center',
		gap: theme.spacing(0.5),
		marginTop: theme.spacing(0.5),
	},
	insightCard: {
		borderRadius: 12,
		boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
	},
	insightRow: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: theme.spacing(1.5),
		padding: theme.spacing(1, 1.5),
		borderRadius: 8,
		marginBottom: theme.spacing(1),
		backgroundColor: 'rgba(79, 70, 229, 0.05)',
	},
	insightBullet: {
		width: 8,
		height: 8,
		borderRadius: '50%',
		background: GRADIENT,
		marginTop: 7,
		flexShrink: 0,
	},
	legend_root: {
	},

	emergency_title: {
		color: theme.palette.primary.contrastText,
		backgroundColor: SIREN_COLOR.EMERGENCY_BG2_COLOR,
	},

	caution_title: {
		color: theme.palette.primary.contrastText,
		backgroundColor: SIREN_COLOR.CAUTION_BG2_COLOR,
	},

	absence_title: {
		color: theme.palette.primary.contrastText,
		backgroundColor: SIREN_COLOR.ABSENCE_BG2_COLOR,
	},

	// sleep_title: {
	// 	color: theme.palette.primary.contrastText,
	// 	backgroundColor: SIREN_COLOR.SLEEP_BG2_COLOR,
	// },


	activity_title: {
		color: theme.palette.primary.contrastText,
		backgroundColor: SIREN_COLOR.ACTIVITY_BG2_COLOR,
	},

	quiver_title: {
		color: theme.palette.primary.contrastText,
		backgroundColor: SIREN_COLOR.QUIVER_BG2_COLOR,
	},

	non_activity_title: {
		color: theme.palette.primary.contrastText,
		backgroundColor: SIREN_COLOR.NON_ACTIVITY_BG2_COLOR,
	},



	others_title: {
		color: theme.palette.primary.contrastText,
		backgroundColor: SIREN_COLOR.OTHERS_BG2_COLOR,
	},

	avatar: {
		backgroundColor: red[500],
		width: theme.spacing(2),
		height: theme.spacing(2),
	},
	// small: {
	//   width: theme.spacing(3),
	//   height: theme.spacing(3),
	// },

	content: {
		marginTop: theme.spacing(2),
	},
	row: {
		height: "42px",
		display: "flex",
		alignItems: "center",
		marginTop: theme.spacing(1),
	},
	spacer: {
		flexGrow: 1,
	},
	actionIcon: {
		marginRight: theme.spacing(1)
	},

	datepicker: {
		display: 'flex',
		// flexDirection: 'row',
		alignItems: 'center',
		alignContent: 'center',

		fontSize: '20px',

	},
	option: {
		fontSize: 15,
		'& > span': {
		  marginRight: 10,
		  fontSize: 18,
		},
	},
}));

